const CAPTURE_FLAG = "captureOuverte";
const STORAGE_KEY = "vocabularium_capture_tabs";
const DRAFT_MAX_AGE_MS = 12 * 60 * 60 * 1000;

function browserStorage() {
  try {
    if (typeof window === "undefined") return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function readMap(storage) {
  try {
    const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(storage, map) {
  const now = Date.now();
  const fresh = {};
  Object.entries(map).forEach(([token, draft]) => {
    if (!draft || now - Number(draft.at || 0) > DRAFT_MAX_AGE_MS) return;
    fresh[token] = draft;
  });
  storage.setItem(STORAGE_KEY, JSON.stringify(fresh));
  return fresh;
}

function newToken() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function storeCaptureDraft(draft, storage = browserStorage()) {
  if (!storage) return "";
  const token = newToken();
  const map = readMap(storage);
  map[token] = {
    mot: String(draft?.mot || ""),
    livre: String(draft?.livre || ""),
    auteur: String(draft?.auteur || ""),
    extrait: String(draft?.extrait || ""),
    at: Date.now(),
  };
  writeMap(storage, map);
  return token;
}

export function readStoredCapture(token, storage = browserStorage()) {
  if (!storage || !token) return null;
  const map = writeMap(storage, readMap(storage));
  const draft = map[token];
  const mot = String(draft?.mot || "").trim();
  if (!mot) return null;
  return {
    mot,
    livre: String(draft.livre || ""),
    auteur: String(draft.auteur || ""),
    extrait: String(draft.extrait || ""),
  };
}

export function readCaptureToken(search = "") {
  try {
    const params = new URLSearchParams(
      search || (typeof window !== "undefined" ? window.location.search : "")
    );
    const token = String(params.get(CAPTURE_FLAG) || "").trim();
    if (!token || token === "1") return "";
    return token;
  } catch {
    return "";
  }
}

export function readCaptureLink(search = "", storage = browserStorage()) {
  const token = readCaptureToken(search);
  if (!token) return null;
  return readStoredCapture(token, storage);
}

export function captureTabUrl(href, token) {
  const url = new URL(href);
  url.search = "";
  url.hash = "";
  url.searchParams.set(CAPTURE_FLAG, token);
  return url.toString();
}

export function openCaptureTab() {
  return window.open("about:blank", "_blank");
}

export function showCaptureInTab(tab, draft) {
  const token = storeCaptureDraft(draft);
  if (!token || !tab || tab.closed) return false;
  tab.location.replace(captureTabUrl(window.location.href, token));
  return true;
}
